"use client";

import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { Suspense } from "react";

import { sortOptions } from "@/data/catalog-ui-content";
import type { CatalogSort } from "@/domain/catalog/search";

export interface SortSelectProps {
  readonly value: CatalogSort;
}

export function SortSelect({ value }: Readonly<SortSelectProps>) {
  return (
    <Suspense fallback={<SortSelectFallback value={value} />}>
      <SortSelectInner value={value} />
    </Suspense>
  );
}

function SortSelectInner({ value }: Readonly<SortSelectProps>) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  return (
    <label className="inline-flex h-11 min-w-0 items-center gap-2 rounded-lg border border-outline-variant bg-surface px-3 text-sm text-muted focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/20">
      <span className="shrink-0">Ordenar por:</span>
      <select
        className="min-w-0 bg-transparent font-bold text-foreground outline-none"
        onChange={(event) => {
          const nextParams = new URLSearchParams(searchParams);
          nextParams.set("sort", event.target.value);
          router.push(`${pathname}?${nextParams.toString()}`);
        }}
        value={value}
      >
        {sortOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}

function SortSelectFallback({ value }: Readonly<SortSelectProps>) {
  return (
    <label className="inline-flex h-11 min-w-0 items-center gap-2 rounded-lg border border-outline-variant bg-surface px-3 text-sm text-muted">
      <span className="shrink-0">Ordenar por:</span>
      <select
        className="min-w-0 bg-transparent font-bold text-foreground outline-none"
        defaultValue={value}
        name="sort"
      >
        {sortOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}
